<template>
  <CRow>
    <CCol>
      <ValidationObserver v-slot="{ handleSubmit }">
        <CCard>
          <CCardHeader> <strong>新增客戶資料 </strong> </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6" class="mb-3">
                <label>客戶類型</label>
                <b-form-radio-group v-model.number="data.type" :options="$modules.CustomerType" @change="changeType">
                </b-form-radio-group>
              </CCol>
              <CCol md="6" class="mb-3">
                <label>介紹人</label>
                <v-select v-model="referrerSelected" @search="getReferrer" :options="referrerlist">
                  <template #no-options="{ search }"> {{ referrerEmptyMessage(search) }} </template>
                </v-select>
              </CCol>

              <CCol md="6">
                <ValidationProvider :rules="{ required: true, regex: /^[A-Za-z]{1,1}[0-9]{3,6}[A-Za-z]{0,1}$/ }"
                  v-slot="v">
                  <CInput label="客戶編號" v-model="data.no" :invalid-feedback="v.errors[0]"
                    :is-valid="v.validated ? v.passed : null" />
                </ValidationProvider>
              </CCol>

              <CCol md="6">
                <CInput label="統一編號" v-model="data.tax" />
              </CCol>

              <CCol md="6">
                <CInput label="事業單位" v-model="data.name" />
              </CCol>

              <CCol md="6">
                <label>地址</label>
                <CRow>
                  <CCol md="3"><b-form-select :options="counties" v-model="data.county"></b-form-select></CCol>
                  <CCol md="3"><b-form-select :options="districts" v-model="data.district"></b-form-select></CCol>
                  <CCol md="6">
                    <CInput v-model="data.address" />
                  </CCol>
                </CRow>
              </CCol>

              <CCol md="6">
                <CInput label="公司電話" v-model="data.phone" />
              </CCol>

              <CCol md="6">
                <CInput label="傳真" v-model="data.fax" />
              </CCol>

              <CCol md="6" class="mb-3">
                <CInput label="電子信箱" v-model="data.email" />
              </CCol>

              <CCol md="6" class="mb-3">
                <CInput label="負責人" v-model="data.manager" />
              </CCol>



              <CCol md="12" class="mb-4">
                <div v-for="(contact, index) in data.contacts" :key="index" class="d-flex align-items-center gap-3">
                  <!-- 聯絡人 -->
                  <CRow>
                    <CCol md="3">
                      <ValidationProvider rules="required" v-slot="v">
                        <CInput class="flex-fill" label="聯絡人" v-model="contact.contactName"
                          :invalid-feedback="v.errors[0]" :is-valid="v.validated ? v.passed : null" />
                      </ValidationProvider>
                    </CCol>
                    <CCol md="3">
                      <ValidationProvider rules="required" v-slot="v">
                        <CInput class="flex-fill" label="聯絡人電話" v-model="contact.contactInformation"
                          :invalid-feedback="v.errors[0]" :is-valid="v.validated ? v.passed : null" />
                      </ValidationProvider>
                    </CCol>
                    <CCol md="3">
                      <CInput class="flex-fill" label="其他聯絡方式" v-model="contact.contactOther" />
                    </CCol>
                    <CCol md="3" class="d-flex align-items-center">
                      <CButton v-if="data.contacts.length > 1" color="danger" size="sm" @click="removeContact(index)">
                        刪除
                      </CButton>
                    </CCol>
                  </CRow>
                </div>
                <CButton color="primary" @click="addContact">新增聯絡人</CButton>
              </CCol>

              <CCol md="12">
                <CInput label="優惠資訊" v-model="data.discount" />
              </CCol>
              <CCol md="12">
                <CTextarea label="備註" rows="5" v-model="data.remark" />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="text-right">
            <CButton color="primary mr-2" @click="handleSubmit(onSubmit)">確認新增</CButton>
          </CCardFooter>
        </CCard>
        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>
      </ValidationObserver>
    </CCol>
  </CRow>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "此欄位為必填選項",
});

extend("regex", {
  ...regex,
  message: "格式錯誤（1個英文字加上數字編號）",
});

export default {
  name: "CustomerCreatePage",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    loading: false,
    referrerlist: [],
    referrerSelected: null,
    data: {
      type: 0,
      referrer: null,
      no: "",
      name: "",
      tax: "",
      county: "",
      district: "",
      address: "",
      phone: "",
      fax: "",
      contactName: "",
      contactInformation: "",
      email: "",
      contactOther: "",
      discount: "",
      remark: "",
      manager: "",
      contacts: [
        {
          contactName: "",
          contactInformation: "",
          contactOther: "",
        },
      ],
    },
    defaultNo: [],
  }),
  computed: {
    counties() {
      return [{ text: "選擇縣市", value: "", disabled: true }, ...this.$modules.CountyList.map((item) => item.name)];
    },
    districts() {
      let result = [{ text: "選擇區域", value: "", disabled: true }];
      if (this.data.county) {
        let list = this.$modules.CountyList.find((item) => item.name === this.data.county).districts.map((item) => item.name);
        result = [...result, ...list];
      }
      return result;
    },
  },
  mounted() {
    this.getDefaultNo();
  },
  methods: {
    changeType() {
      let query = this.defaultNo.find((p) => p.type === this.data.type);
      if (query && query.no) {
        let number = query.no.substring(1).replace(/[a-z]/ig, "");
        this.data.no = query.no.substring(0, 1) + (parseInt(number) + 1).toString().padStart(number.length, "0");
      } else {
        this.data.no = "";
      }
    },
    getDefaultNo() {
      this.$http.get("/customer/no").then((response) => {
        if (response.data.success) {
          this.defaultNo = response.data.result;
          this.changeType();
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    onSubmit() {
      this.loading = true;
      this.data.referrer = this.referrerSelected ? this.referrerSelected.value : null;
      this.$http.post("/customer", this.data).then((response) => {
        if (response.data.success) {
          this.$notify({ type: "success", text: "新增成功" });
          this.$router.push({ name: "客戶資料", params: { id: response.data.result.id } });
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    referrerEmptyMessage(search) {
      if (search) return "查無資料，請輸入其他關鍵字進行搜尋";
      else return "請輸入至少一個關鍵字進行搜尋";
    },
    getReferrer(search, loading) {
      if (search.length) {
        loading(true);
        let params = {
          params: {
            search: search,
          },
        };
        this.$http.get("/customer/entire", params).then((response) => {
          if (response.data.success) {
            this.referrerlist = response.data.result.map((item) => ({
              label: item.no + " - " + item.name,
              value: item.id,
            }));
          } else {
            this.$notify({ type: "error", text: response.data.message });
          }
          loading(false);
        });
      } else {
        this.referrerlist = [];
      }
    },
    addContact() {
      this.data.contacts.push({
        contactName: "",
        contactInformation: "",
        contactOther: "",
      });
    },
    removeContact(index) {
      this.data.contacts.splice(index, 1);
    },
  },
};
</script>
